import { HttpError } from "./http-error";

export interface IHttpService {
  fetch: (url: string, options?: RequestInit) => Promise<Response>;
}

export type AccessTokenProvider = () => Promise<string>;

export class HttpService implements IHttpService {
  public static checkStatus(response: Response) {
    if (response.ok) {
      return response;
    }

    throw new HttpError(response);
  }

  constructor(
    private accessTokenProvider: AccessTokenProvider = () => Promise.resolve("")
  ) {}

  public fetch(url: string, options: RequestInit = {}): Promise<Response> {
    if (!url) {
      throw new Error("url is missing");
    }

    const headers = options.headers
      ? new Headers(options.headers)
      : new Headers();
    if (!headers.has("Accept")) {
      headers.set("Accept", "application/json");
    }

    if (
      !headers.has("Content-Type") &&
      (options.method === "POST" || options.method === "PUT")
    ) {
      headers.set("Content-Type", "application/json");
    }

    return this.accessTokenProvider()
      .then(jwt => {
        if (!headers.has("Authorization") && jwt) {
          headers.set("Authorization", `Bearer ${jwt}`);
        }

        return {
          ...options,
          headers
        };
      })
      .then(requestInit => fetch(url, requestInit))
      .then(HttpService.checkStatus);
  }
}
